export default __webpack_public_path__ + "static/media/flag-china-active.27923bb2.svg";